import React from 'react';
import PropTypes from 'prop-types';
import renderInlineSvg from '~/utils/renderInlineSvg';
import classnames from 'classnames';

import './index.scss';

export const ActionPillStyles = {
  DEFAULT: 'default',
  NEUTRAL_BORDERED: 'neutral-bordered'
};

export const ActionPillClasses = {
  WRAPPER: 'ndx-ActionPill-wrapper',
  ICON: 'action-pill-icon',
  TEXT: 'action-pill-text'
};

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export const ActionPill = props => {
  const {icon, isIconDefinedInStyle, text, pillStyle, onClick} = props;

  function render() {
    switch (pillStyle || ActionPillStyles.DEFAULT) {
      case ActionPillStyles.DEFAULT:
        return renderDefaultStyle();
      case ActionPillStyles.NEUTRAL_BORDERED:
        return renderNeutralBorderedStyle();
      default:
        return renderDefaultStyle();
    }
  }

  function renderDefaultStyle() {
    return renderActionPillWithStyle({
      styleClassName: ActionPillStyles.DEFAULT
    });
  }

  function renderNeutralBorderedStyle() {
    return renderActionPillWithStyle({
      styleClassName: ActionPillStyles.NEUTRAL_BORDERED
    });
  }

  function renderActionPillWithStyle({styleClassName}) {
    if (!icon || !text || !onClick) {
      return;
    }

    return (
      <div
        className={classnames(ActionPillClasses.WRAPPER, [styleClassName])}
        onClick={onClick}>
        {isIconDefinedInStyle ? (
          <div className={classnames(ActionPillClasses.ICON, [icon])} />
        ) : (
          <div
            className={ActionPillClasses.ICON}
            dangerouslySetInnerHTML={renderInlineSvg(icon)}
          />
        )}
        <div className={ActionPillClasses.TEXT}>{text}</div>
      </div>
    );
  }

  return render();
};

const propTypes = {
  icon: PropTypes.any,
  isIconDefinedInStyle: PropTypes.bool,
  pillStyle: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func
};

ActionPill.propTypes = propTypes;

export default ActionPill;
